import React, { Component } from "react";
import { connect } from "react-redux";
import { Collapse } from "antd";

import SubjectItem from "components/atar/SubjectItem";
import { ACTION_TYPE } from "reducers/actionType";
import { MOST_RELEVANT_SUBJECTS, LOAD_MORE_AMOUNT } from "utils/helpers";
import MasterButton, { BUTTON_TYPES } from "components/ui/MasterButton";
import "styles/Cluster.scss";
import "styles/OtherRelevantSubjects.scss";
import TableTopPopOver from "./pop-overs/TableTopPopOver";
const Panel = Collapse.Panel;

class OtherRelevantSubjects extends Component {
  state = { count: 0 };

  componentDidMount = () => {
    this.loadMore();
  };

  loadMore = () => {
    this.setState((prevState, props) => ({
      count: prevState.count + LOAD_MORE_AMOUNT
    }));
  };

  handleToggleSubject = idNum => {
    const newSub = idNum.toString();
    const { userAddSubs } = this.props;
    const newUserAddSubs = Array.from(userAddSubs);
    if (newUserAddSubs.includes(newSub)) {
      newUserAddSubs.splice(newUserAddSubs.indexOf(newSub), 1);
      this.props.dispatch({
        type: ACTION_TYPE.pickAddSubs,
        data: { userAddSubs: newUserAddSubs }
      });
      return;
    }

    const { userOthSubs } = this.props;
    const newUserOthSubs = Array.from(userOthSubs);
    if (newUserOthSubs.includes(newSub)) {
      newUserOthSubs.splice(newUserOthSubs.indexOf(newSub), 1);
    } else {
      newUserOthSubs.push(newSub);
    }
    this.props.dispatch({
      type: ACTION_TYPE.pickOthSubs,
      data: { userOthSubs: newUserOthSubs }
    });
  };

  countClusterUnits = (acc, o) => {
    // recusively traverse through the group to count the number of units which have been selected
    if (o.type === "G") {
      const { group } = o;
      return group.reduce(this.countClusterUnits, acc);
    } else {
      const { subject } = o;
      const { userOthSubs } = this.props;
      // check if subject has been selected
      if (userOthSubs.includes(subject.subject_num.toString())) {
        return acc + subject.units;
      } else {
        return acc;
      }
    }
  };

  // recursive function renders return items for this component
  renderSubjectItems = o => {
    const { userAddSubs, userOthSubs } = this.props;

    if (o.type === "G") {
      const { group } = o;
      return (
        <Collapse
          bordered={false}
          className="cluster-container"
          key={o.identifier}
        >
          <Panel
            header={
              <div className="flex-space-between" style={{ width: "100%" }}>
                <h1 className="title">{o.identifier}</h1>

                {this.countClusterUnits(0, o) !== 0 && (
                  <div className="tag-cluster-count">
                    {this.countClusterUnits(0, o)}
                  </div>
                )}
              </div>
            }
            key="1"
            className="cluster-panel"
          >
            {group.map(sub => this.renderSubjectItems(sub))}
          </Panel>
        </Collapse>
      );
    } else {
      const { subject } = o;
      const key = subject.subject_num.toString();

      return (
        <SubjectItem
          {...subject}
          handleToggleSubject={() =>
            this.handleToggleSubject(subject.subject_num)
          }
          subjectItemSelected={
            userAddSubs.includes(key) || userOthSubs.includes(key)
          }
          showSelect={true}
          subjectError={this.props.subjectErrorOb[subject.subject_num]}
        />
      );
    }
  };

  render() {
    const { recommendations } = this.props;

    return (
      <div className="other-relevant-subjects">
        <h1 className="title padding-sides">Other relevant subjects</h1>
        <TableTopPopOver />

        {recommendations
          .slice(
            MOST_RELEVANT_SUBJECTS,
            MOST_RELEVANT_SUBJECTS + this.state.count
          )
          .map(rec => this.renderSubjectItems(rec))}
        <div className="other-button-container">
          {this.state.count + MOST_RELEVANT_SUBJECTS <
            recommendations.length && (
            <MasterButton
              type={BUTTON_TYPES.CLEAR}
              text="View more"
              callback={this.loadMore}
            />
          )}
        </div>
      </div>
    );
  }
}
const mapStateToProps = store => {
  const { input } = store.inputReducer;
  const { recommendations } = store.recommendationsReducer;
  const { userOthSubs } = store.pickOthSubReducer;
  const { userAddSubs } = store.pickAddSubReducer;
  return { input, userAddSubs, recommendations, userOthSubs };
};

export default connect(mapStateToProps)(OtherRelevantSubjects);
